import ApiBase from '@/api/base';

export default {
  signinAdmin () {
    return ApiBase.post(`/admin/signin`);
  },
  signoutAdmin () {
    return ApiBase.postWithCredentials(`/admin/signout`);
  },
  sidekiqAuth () {
    return ApiBase.postWithCredentials(`/admin/sidekiq/auth`);
  },
};
